<template>

    <div class="store_chatroom_list">
        <!--表頭-->
        <div class="page_top">
            <div class="title">
                <i class="icon" id="icon" @click="back()"></i>
                <span class="header-text">聯絡賣家</span>
            </div>
        </div>
        <!--滾動內容頁-->
        <div class="sh_page_padding" v-infinite-scroll="getChannel" :infinite-scroll-disabled="loading || page > lastPage">
            <el-backtop target=".sh_page_padding"></el-backtop>
            <div class="container-fluid bg-white" style="min-height: 100%">
                <!--搜尋商家-->
                <el-input placeholder="搜尋商家" v-model="search" class="my-1" @clearable="true" @input="searchCompany">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <!--無訊息-->
                <el-empty description="尚無訊息" v-if="!chatrooms.length && loading==false"></el-empty>
                <!--聊天室列表-->
                <div v-for="chatroom in chatrooms" :key="chatroom.id">
                    <div class="d-flex align-items-center my-3"
                         @click="goChatroom(chatroom.channelId,chatroom.channelName,chatroom.showName)">
                        <!--頭像-->
                        <div class="me-2">
                            <el-badge is-dot v-if="chatroom.notRead == 1">
                                <el-avatar size="large" icon="el-icon-user-solid" :src="chatroom.avatar"></el-avatar>
                            </el-badge>
                            <el-avatar v-else size="large" icon="el-icon-user-solid" :src="chatroom.avatar"></el-avatar>

                        </div>
                        <!--聊天室資訊-->
                        <div class=" overflow-hidden  text-truncate " style="width: 100vw">
                            <div class=" d-flex justify-content-between mb-2">
                                <!--姓名-->
                                <span class=" overflow-hidden  text-truncate text-nowrap fw-bold chatroom-name">
                                            {{ chatroom.showName }}
                                        </span>
                                <!--日期-->
                                <span class="chatroom-date">{{ displayDateTime(chatroom.createdAt) }}</span>
                            </div>
                            <!--訊息-->
                            <p class="text-nowrap chatroom-message text-truncate" style="max-width: 100vw">
                                {{ chatroom.message }}</p>
                        </div>
                    </div>
                    <el-divider class="my-1"></el-divider>
                </div>
                <!--頁面載入中-->
                <div class="d-flex justify-content-center align-items-center h-100 my-2">
                    <i class="el-icon-loading my-2" v-if="loading"></i>
                </div>

            </div>
        </div>
    </div>
</template>
<style>
.el-input__inner {
    background-color: #F2F6FC;
}

.el-input__prefix {
    color: #909399;
}

.el-input__inneri, .el-input__inner::placeholder {
    color: #909399;
}

.chatroom-name {
    color: #303133;
    font-size: 18px;
}

.chatroom-date {
    color: #909399;
    font-size: 14px;
}

.chatroom-message {
    color: #606266;
    font-size: 16px;
}

</style>
<script>
import moment from 'moment/min/moment-with-locales'
import FN from "@/components/fn.vue";

export default {
    mixins: [FN],
    data() {
        return {
            search: '', // 搜尋商家
            loading: true,  // 頁面載入中
            page: 1,    // 頁數
            lastPage: 1,    // 最後一頁
            chatrooms: [],  // 聊天室列表
        }
    },
    mounted() {
        //  日期文字設定
        moment.locale('zh-tw');
        this.getChannel();

    },
    methods: {
        /** 返回上一頁 */
        back() {
            this.$router.go(-1)
        },
        /** 進入聊天室 */
        goChatroom(id, channel, showName) {
            showName = encodeURIComponent(showName);
            this.$router.push({name: 'StoreChatroom', params: {id: id, channel: channel,showName:showName}});
        },
        /** 顯示時間 */
        displayDateTime(dateToCheck) {

            const momentObj = moment(dateToCheck);
            const today = moment().startOf('day');

            if (momentObj.isSame(today, 'd')) {
                return moment(dateToCheck).format('HH:mm');
            } else {
                const diffInDays = moment().diff(momentObj, 'days');
                const formatString = diffInDays >= 365 ? 'YYYY/MM/DD' : 'MM/DD ddd';
                return momentObj.format(formatString);
            }
        },
        /** 取得聊天室列表 */
        getChannel() {
            if (this.page > this.lastPage) {
                return;
            }
            this.loading = true;
            this.FETCH({
                key: 'GET_CHANNEL',
                search: this.search,
                page: this.page,
            }).then((res) => {
                if (+(res || {}).code === -3) {
                    this.checkNewToken(this.getChannel)
                } else if (+(res || {}).code === 0) {
                    this.lastPage = res.pagination.last_page;
                    /** 新增聊天室 */
                    this.addChatrooms(res.pagination.data);
                    this.page++;
                } else {
                    console.log(res);
                    this.$message('網路異常，請稍後再試');
                }
                this.loading = false;
            });
        },
        /** 新增聊天室 */
        addChatrooms(newChatrooms) {
            newChatrooms.forEach((newChatroom) => {
                if (!this.chatrooms.some(chatroom => chatroom.channelId === newChatroom.channelId)) {
                    this.chatrooms.push(newChatroom);
                }
            });
        },
        /** 搜尋商家 */
        searchCompany() {
            this.page = 1;
            this.lastPage = 1;
            this.chatrooms = [];
            this.loading = true;
            this.getChannel();
        }
    }
}
</script>




